import { useMemo } from "react";
import { getAddressText } from "@b2bportal/core-utilities";
import type { HotelShopMapComponentProps } from "./HotelShopMap";

export const useHotelShopMap = ({ hotel }: HotelShopMapComponentProps) => {
  return useMemo(() => {
    return {
      context: {
        coordinates: hotel.lodging.location.coordinates,
        //Google static maps requires hex colors to start with 0x
        markerColor: "0x2A1050",
      },
      text: {
        hotelName: hotel.lodging.name,
        address: getAddressText(hotel.lodging.address),
      },
    };
  }, [hotel]);
};
